import ContributorComponent from "components/contributorComponent/ContributorComponent";

function Contributor() {
  return (
    <div>
      <ContributorComponent />
    </div>
  );
}

export default Contributor;
